module.exports = __webpack_public_path__ + "static/media/entrance.8d0565fc.jpg";